export default {
  "base": "border-t border-(--ui-border) my-12"
}